// extracted by css-extract-rspack-plugin
export default {"field":"field-CQPOXO","preview":"preview-hLYwoM","summary":"summary-K_jiCR","body":"body-m3iZ8r"};